<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查任务创建
      </div>
    </div>
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      class="mt20"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="任务名称" prop="itemName">
            <el-input v-model="form.itemName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="开始时间" prop="startTime">
            <el-date-picker
              type="datetime"
              placeholder="选择日期"
              v-model="form.startTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>

            <!-- <el-col class="line" :span="3">结束时间</el-col> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker
              type="datetime"
              placeholder="选择日期"
              v-model="form.endTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>

            <!-- <el-col class="line" :span="3">结束时间</el-col> -->
          </el-form-item>
        </el-col>
        <!-- <el-col :span="20">
          <el-form-item label="巡查方式" prop="remarks">
            <el-select v-model="form.region" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
    <div class="content_line"></div>
    <h2 class="content">巡查内容配置</h2>
    <div style="display:flex">
      <div class="choose">
        <div
          class="mt10"
          style="
                  border-bottom: 1px solid #ccc;
                  padding-bottom: 10px;
                  font-weight: 900;
                   width:100%;
                  text-align: center;
                "
        >
          巡查区域列表
        </div>
        <div style="height: 90%; " class="gundong">
          <div
            class="areaitem"
            v-for="item in areaList"
            :class="params1.areaId === item.areaId ? 'mark' : ''"
            @click="chooseArea(item)"
          >
            {{ item.areaName }}
          </div>
        </div>
      </div>
      <div class="flex1 gundong">
        <div class="common-page common-list " style="margin: 0">
          <el-table
            :data="listCopy"
            class="mt10"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :row-key="getRowKeys"
          >
            <el-table-column
              type="selection"
              width="55"
              :reserve-selection="true"
            >
            </el-table-column>
            <el-table-column
              prop="pointNum"
              label="巡查点编号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pointName"
              label="巡查点名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pointAddr"
              align="center"
              label="巡查点位置"
            ></el-table-column>
            <el-table-column
              prop="areaName"
              align="center"
              label="巡查区域"
            ></el-table-column>
          </el-table>
        </div>
        <!-- <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total1"></el-pagination> :page-sizes="10" -->
        <!-- <el-pagination
          class="pagination"
          background
          layout="prev, pager, next"
          :current-page.sync="params1.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size.sync="params1.pageSize"
          :total="total"
        >
        </el-pagination> -->
      </div>
      <div class="checkRightTotle gundong" >
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >目标列表</el-checkbox
        >
        <div style="border-bottom:1px dashed grey;"></div>
        <el-checkbox-group
          v-model="checkedPoint"
          @change="handleCheckedCitiesChange"
          class="checkflex"
        >
          <el-checkbox
            v-for="item in list"
            :label="item.id"
            :key="item.pointNum"
            >{{ item.pointName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
    <div class="content_line"></div>
    <h2 class="content">巡查人员配置</h2>
    <div style="margin-left:60px;margin-top:30px">
      <span>搜索名称：</span>
      <el-input
        style="display:inline-block;width:200px;height:50px"
        placeholder="请输入内容"
        v-model="input2"
        @change='changeSearch'
      >
      </el-input>
    </div>
    <div class="personPad">
      <el-checkbox-group
        v-model="checkListPerson"
        @change="checkedPersonChange"
      >
        <el-checkbox
          v-for="item in personListCopy"
          :label="item.userId"
          :key="item.userId"
          >{{ item.nickName }}</el-checkbox
        >
      </el-checkbox-group>
    </div>

    <div class="btn-box center">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button type="primary" class="ml20" @click="$router.back()"
        >返回</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checkAll: false,
      checkedPoint: [],
      checkListPerson: [],
      form: {
        endTime: "",
        startTime: "",
        itemName: "",
      },
      areaList: [],
        id:this.$route.query.id,
        quick:this.$route.query.quick,
      cpNum: this.$route.query.cpNum,
      params: {
        page: 1,
        c_point_name: "",
        c_point_addr: "",
        c_point_number: "",
        c_point_area: "",
        c_company_num: this.$store.state.user.company.cCompanyNum || "",

        c_point_area_id: "",
      },
      params1: {
        companyNum: this.$route.query.cpNum,
        pageNum: 1,
        areaId: "",
        pageSize: 10,
      },
      list: [],
      listCopy: [],
      personList: [],
      personListCopy: [],
      multipleSelection: [],
      total: 0,
      isIndeterminate: true,
      input2: "",
      rules: {
        itemName: [
          { required: true, message: "请填写任务名称", trigger: "change" },
        ],
        startTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
    };
  },

  created() {
    // this.getList()
           this.getDatas();
    this.getPerson();
   
    if (this.id&&!this.quick) {
      setTimeout(()=>{
         this.getEditData()
    },500)
    }else{

    }
    if (this.id&&this.quick) {
      setTimeout(()=>{
         this.getQUikc()
    },500)
    }
    
   
  },
  methods: {
    getQUikc(){
      this.$get('/relic/relicInspectionItem/quickDelivery/'+this.id).then(res=>{
        console.log(res);
         this.form.endTime=res.data.endTime
            this.form.startTime=res.data.startTime
            this.form.itemName=res.data.itemName
            this.checkedPoint=res.data.pointIdList?res.data.pointIdList:[]
            this.rightTurnLeft(this.checkedPoint)
            this.checkListPerson=res.data.userIdList?res.data.userIdList:[]
      })
    },
    getEditData(){
        this.$get('/relic/relicInspectionItem/getEditInfo/'+this.id).then(res=>{
            console.log(res,11111111);
            this.form.endTime=res.data.endTime
            this.form.startTime=res.data.startTime
            this.form.itemName=res.data.itemName
            this.checkedPoint=res.data.pointIdList
            this.rightTurnLeft(this.checkedPoint)
            this.checkListPerson=res.data.userIdList
            console.log(this.checkedPoint,'0000');
        })
    },
      changeSearch(){
    // console.log(this.input2,this.personListCopy);
    this.personListCopy=this.personList.filter(item=>item.nickName.includes(this.input2))
  },
    checkedPersonChange(val) {
      console.log(val, "person");
    },
    handleCheckAllChange(val) {
      //   console.log(val,this.list);

      let data;
      if (val) {
        data = this.list.map((item) => item.id);
      } else {
        data = [];
      }

      //   console.log(data);
      this.checkedPoint = val ? data : [];
      this.isIndeterminate = false;
      this.rightTurnLeft(data);
    },
    //   选中右侧
    handleCheckedCitiesChange(value) {
      // console.log(value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.list.length;
      // 
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.list.length;
      this.rightTurnLeft(value);
    },
    rightTurnLeft(value) {
      // console.log(value,33333333);
      if (value.length > 0) {
       console.log(this.listCopy);
      //  zengjia
        // this.listCopy.forEach((item) => {
        //      console.log(item,'jinlai');
        //   value.forEach((i) => {
           
        //     if (item.id == i) {
                 
        //       this.$refs.multipleTable.toggleRowSelection(item, true);
        //     }else{
        //       console.log('00000');
        //       // this.$refs.multipleTable.clearSelection();
        //       // this.$refs.multipleTable.toggleRowSelection(item, false);
        //     }
        //   });
          
        // });
        // jianshao
       let cancel= this.listCopy.filter(item=>{
        // console.log(item,value)
          const val = value.some(itemB=>itemB==item.id)
          this.$refs.multipleTable.toggleRowSelection(item, val);
          return val
          // return value.every(itemB=>{
          //   return itemB!=item.id
          // })
        } )
        // let cancel=this.listCopy.filter(item=>{
        //   return value.every(itemB=>{
        //     return itemB!=item.id
        //   })
        // } )
        // cancel.forEach(item=>{
        //   this.$refs.multipleTable.toggleRowSelection(item, false);
        // })
        // console.log(cancel,'cancel');
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    handleSelectionChange(val) {
    //   console.log(val);
      this.multipleSelection = val;
      //   console.log(this.multipleSelection);
      this.checkedPoint = this.multipleSelection.map((item) => item.id);
    },
    getDatas() {
      this.$get(
        "/relic/relicInspectionCompanyArea/listNotPage?companyNum=" + this.cpNum
      ).then((res) => {
   
        // if (res.data.length) {
        this.areaList = res.data;
        var obj = { areaId: "", areaName: "全部点位" };
        this.areaList.unshift(obj);
        // this.params1.areaId = res.data[0].areaId;
        this.getList();
      });
    },
    chooseArea(it) {
      // console.log(it,this.list,66666666);
      this.params1.pageNum = 1;
      this.params1.areaId = it.areaId;
      let data = this.list.map((item, index) => {
        if (it.areaName == "全部点位") {
          return item;
        }
        if (item.areaId == it.areaId) {
          return item;
        }
      });
      this.listCopy = data.filter((item) => item);


      // this.getList();
      // }
    },
    handleSizeChange(val) {
      this.params1.pageSize = val; //更新每页的条数
      //   this.getList(); //重新获取列表数据
    },
    handleCurrentChange() {
      this.params1.pageNum = val; //重新获取列表数据
      //   this.getList();
    },
    getList() {
      this.$get("/relic/relicInspectionPoint/listNotPage", this.params1).then(
        (res) => {
          // console.log(res,4444);
         let paixu= res.data.sort((a,b)=>{
            return a.id-b.id
          })
          // console.log(paixu,'paixu');
          this.list = paixu;
          this.listCopy = paixu;
          // this.total1 = res.count;
        }
      );
    },
    getPerson() {
      this.$get(
        "/relic/inspectionUser/selectPerson?companyNum=" + this.cpNum 
      ).then((res) => {
  
        this.personList = res.data;
        this.personListCopy=res.data;
      });
    },
    onSubmit() {
                let pointIdList = this.checkedPoint;
          let userIdList = this.checkListPerson;
      if (pointIdList.length == 0 || userIdList.length == 0) {
            this.$message({
              message: "请先勾选巡查内容和巡查人员",
              type: "warning",
              duration: 1000,
            });
            return
          }
      this.$refs.form.validate((valid) => {
        if (valid) {

          
          pointIdList=pointIdList.sort((a,b)=>{
            return a-b
          })
          userIdList=userIdList.sort((a,b)=>{
            return a-b
          })
          // console.log(pointIdList,userIdList,1111)
          let data = {
            companyNum: this.cpNum,
            ...this.form,
            pointIdList:pointIdList,
            userIdList:userIdList
          };

          if (this.id&&!this.quick) {
            data.id=this.id
            this.$put('/relic/relicInspectionItem/editInfo',data).then(res=>{
            console.log(res);
            if (res.code==200) {
                 this.$message({
              message: "操作成功",
              type: "success",
              duration: 1000,
            });
                this.$router.back()
            }
          })
          }else{
             this.$post('/relic/relicInspectionItem/addInfo',data).then(res=>{
            console.log(res);
            if (res.code==200) {
                 this.$message({
              message: "操作成功",
              type: "success",
              duration: 1000,
            });
                this.$router.back()
            }
          })
          }
         
        } else {
          this.$message({
            message: "请填写表格",
            type: "warning",
            duration: 1000,
          });
          return;
        }
      });
    },
  },
};
</script>
<style scoped>
.content {
  display: inline-block;
  margin-left: 30px;
  width: 15%;
}
.content_line {
  width: 100%;
  height: 20px;
  margin-left: 10px;
  margin-bottom: 15px;
  border-bottom: 1px dashed rgb(182, 182, 182);
}
.mark {
  background: #3d62de;
  color: #fff;
}
.choose {
  border-radius: 10px;
  width: 20%;
  height: 550px;
  border: 1px solid #ccc;
}
.areaitem {
  height: 30px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border-bottom: 1px groove;
  margin-right: 20px;
  cursor: pointer;
}
.checkRightTotle {
  width: 260px;
  height: 550px;
  border: 1px solid rgb(194, 193, 193);
  padding: 30px;
}
.checkflex {
  display: flex;
  flex-direction: column;
}
.personPad {
  padding: 30px;
}
.footer {
  width: 100%;
  height: 100px;
  overflow: hidden;
  /* display: flex;
  justify-content: center; */
}
.gundong{
  height: 550px;
  overflow-y: scroll;
}
 ::-webkit-scrollbar {
    width: 10px; /*对垂直流动条有效*/
    height: 5px; /*对水平流动条有效*/
  }

  /*定义滚动条的轨道颜色、内阴影及圆角*/
  ::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
    border-radius: 8px;
  }

  /*定义滑块颜色、内阴影及圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    background-color: #e8e8e8;
  }
</style>
